module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "link-wrapper",
    attrs: {
      "href": _vm.product.productUrl
    }
  }, [_c('div', {
    staticClass: "campaign-card",
    class: {
      wide: _vm.wide
    }
  }, [_c('div', {
    staticClass: "image",
    style: ('background-image: url(' + _vm.product.image + ')')
  }), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('h4', [_vm._v("\n        " + _vm._s(_vm.product.projectTitle) + "\n        "), _vm._m(0, false, false)]), _vm._v(" "), _c('p', {
    staticClass: "countdown"
  }, [_vm._v(_vm._s(_vm.daysLeft))]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.product.description))])]), _vm._v(" "), _c('a', {
    staticClass: "lnk-arrw ra-cta",
    attrs: {
      "href": _vm.product.productUrl
    }
  }, [_vm._v("Learn more")])]), _vm._v(" "), _c('div', {
    staticClass: "goal-wrapper"
  }, [_c('div', {
    staticClass: "progress-bar"
  }, [_c('div', {
    staticClass: "progress-bar-wrapper"
  }, [_c('div', {
    staticClass: "progress-bar-inner",
    style: ({
      width: _vm.goalProgress + '%'
    })
  })])]), _vm._v(" "), _c('p', [_vm._v("\n          $" + _vm._s(_vm.formatCurrency(_vm.product.currentDonationAmount)) + " of $" + _vm._s(_vm.formatCurrency(_vm.product.goalAmount))), _c('span', {
    staticClass: "hide-mobile"
  }, [_vm._v(" raised")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "card-arrow"
  }, [_c('i', {
    staticClass: "fas fa-chevron-right"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5147ad48","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=4ecaiejb649!./~/string-replace-webpack-plugin/loader.js?id=vjos074u90o!./src/components/impact-project/Card.vue
// module id = 806
// module chunks = 0